module.exports = __webpack_public_path__ + "static/media/tf.5674a2e8.jpg";